import {
    Chip,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { CounterpartyPerson } from "../counterpartyApi";


export const CounterpartyPeopleTab = ({
    people,
    onEdit,
}: {
    people: CounterpartyPerson[];
    onEdit: (id: number) => void;
}) => {
    if (!people || people.length === 0) {
        return <Typography variant="body2" color="text.secondary">Brak kontaktów</Typography>;
    }

    const fullName = (p: CounterpartyPerson) =>
        [p.firstName, p.lastName].filter(Boolean).join(" ") || "—";

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Osoba</TableCell>
                    <TableCell>Stanowisko</TableCell>
                    <TableCell>Dział</TableCell>
                    <TableCell align="right">Akcje</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {people.map((p) => (
                    <TableRow key={p.id} hover>
                        <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="body2">{fullName(p)}</Typography>
                                {p.isPrimary && <Chip size="small" label="Primary" />}
                            </Stack>
                        </TableCell>
                        <TableCell>{p.jobTitle ?? "—"}</TableCell>
                        <TableCell>{p.department ?? "—"}</TableCell>
                        <TableCell align="right">
                            <Tooltip title="Edytuj">
                                <IconButton size="small" onClick={() => onEdit(p.id)}>
                                    <EditOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};